import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  login(email, pwd, remember) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          logIn (
            email: "${email}",
            password: "${pwd}",
            remember: ${remember}
          ) {
            token,
            user {
              id,
              name,
              username,
              email,
              image,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              isConnected
            }
          }
        }
      `
    })
  },
  refreshToken() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `mutation refreshToken { refreshToken { token } }`
    })
  },
  disconnected() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          disconnected
        }
      `
    })
  }
}
